<template>
  <span>
    <template v-if="$store.state.TravelService.editedTravelServiceItem !== null">
      <order-service-hotel-dialog v-if="$store.state.TravelService.editedTravelServiceItem.type === 'hotel'" />
      <order-service-car v-if="$store.state.TravelService.editedTravelServiceItem.type === 'car'" />
      <order-service-rail v-if="$store.state.TravelService.editedTravelServiceItem.type === 'rail'" />
      <order-service-flight v-if="$store.state.TravelService.editedTravelServiceItem.type === 'flight'" />
      <order-service-other v-if="$store.state.TravelService.editedTravelServiceItem.type === 'other'" />
      <order-service-insurance-dialog v-if="$store.state.TravelService.editedTravelServiceItem.type === 'insurance'" />
    </template>
  </span>
</template>

<script>
import OrderServiceHotelDialog from "./OrderServiceHotelDialog";
import OrderServiceRail from "./OrderServiceRail";
import OrderServiceFlight from "./OrderServiceFlight";
import OrderServiceCar from "./OrderServiceCar";
import OrderServiceOther from "./OrderServiceOther";
import OrderServiceInsuranceDialog from "./OrderServiceInsuranceDialog";
export default {
  name: "OrderServiceItemDialog",
  components: { OrderServiceInsuranceDialog, OrderServiceOther, OrderServiceCar, OrderServiceFlight, OrderServiceRail, OrderServiceHotelDialog }
};
</script>

<style scoped></style>
